import { render, staticRenderFns } from "./RWidgetStatus.vue?vue&type=template&id=688ef4d6&scoped=true&"
import script from "./RWidgetStatus.vue?vue&type=script&lang=js&"
export * from "./RWidgetStatus.vue?vue&type=script&lang=js&"
import style0 from "./RWidgetStatus.vue?vue&type=style&index=0&id=688ef4d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688ef4d6",
  null
  
)

export default component.exports